<template>
  <div>
    <slot
      :open="open"
      :link="link"
    />
    <BaseDialog
      v-model="modalOpened"
      close
      content-width="910px"
    >
      <BaseCard
        v-model="modalOpened"
        class="m_bg-white m_pa16 m_pt8"
      >
        <div
          v-if="contentLoaded"
          class="m_pa30 m_flex m_justify-center"
        >
          <BaseLoader
            variant="page"
          />
        </div>
        <div
          v-else
          class="content"
        >
          <my-shadow-content :content="content" />
        </div>
      </BaseCard>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  inject,

  ref,
  watch,
} from 'vue';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import BaseLoader from '@/shared/lib/uikit/components/BaseLoader/BaseLoader.vue';
import { RequestFactory } from '@/shared/module/RequestFactory';
import {
  aliveFancyboxClose,
  closeFromInsideModal,
} from './shadowContent';
import { configEnv } from '@/shared/config-env';

export default defineComponent({
  components: { BaseLoader, BaseCard, BaseDialog },
  setup() {
    const modalOpened = ref(false);
    const contentLoaded = ref(true);
    const synergyRuRequest = inject('synergyRuRequest') as RequestFactory;
    const content = ref('');

    const open = async () => {
      try {
        modalOpened.value = true;
        const request = synergyRuRequest.requestOfGet('/lp/privacy-common/');
        await request.send();
        content.value = request.response();
        aliveFancyboxClose();
      } catch (e) {
        throw new Error('Не удалось загрузить контент политики', e);
      } finally {
        contentLoaded.value = false;
      }
    };

    watch(closeFromInsideModal, () => {
      modalOpened.value = false;
    });

    return {
      open,
      modalOpened,
      contentLoaded,
      content,
      link: configEnv.SYNERGY_PRIVACY_URL,
    };
  },
});
</script>
